export default __webpack_public_path__ + "static/media/card1.0b40e35c.png";